import { render, staticRenderFns } from "./DocumentFragmentScroller.vue?vue&type=template&id=3be4a8ed&scoped=true"
import script from "./DocumentFragmentScroller.vue?vue&type=script&lang=ts"
export * from "./DocumentFragmentScroller.vue?vue&type=script&lang=ts"
import style0 from "./DocumentFragmentScroller.vue?vue&type=style&index=0&id=3be4a8ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be4a8ed",
  null
  
)

export default component.exports